import { Typography } from '@material-ui/core';

import useStyles from '@components/common/list-with-list-style-image/styles';

interface Props {
  list: Array<string>;
  image: string;
  boldTitle?: true;
}

const ListWithListStyleImage: React.FC<Props> = (props) => {
  const { list, image, boldTitle } = props;

  const classes = useStyles();

  const listItems = list.map((item) => (
    <li key={item}>
      <img src={image} alt="icon" className={classes.icon} />
      {boldTitle ? (
        <Typography variant="subtitle1">{item}</Typography>
      ) : (
        <Typography variant="body2">{item}</Typography>
      )}
    </li>
  ));

  return <ul className={classes.list}>{listItems}</ul>;
};

export default ListWithListStyleImage;
